import styled from '@emotion/styled'
import { CartItem, CartItemGroups } from '@open-tender/types'
import { getItemOptions } from '@open-tender/utils'
import { ButtonLink } from 'components'
import Body from 'components/Body'
import Heading from 'components/Heading'
import MenuItemSelectedOption from './MenuItemSelectedOption'

const MenuItemSelectionsView = styled.div`
  padding: 2rem ${(props) => props.theme.item.desktop.padding};
  padding-bottom: 0;
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: 2rem ${(props) => props.theme.item.mobile.padding};
    padding-bottom: 0;
  }
`

const MenuItemSelectionsEdit = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }
`

const MenuItemSelectionsTitle = styled(Heading)`
  font-size: ${(props) => props.theme.fonts.sizes.main};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.small};
  }
`

const MenuItemSelectionsContainer = styled.div`
  margin: 0.6rem 0 0;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }
`

const MenuItemSelectionsOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin: 1.1rem 0 0;

  & > span {
    margin-bottom: 0.6rem;
  }
`

const MenuItemSelectionsIncomplete = styled(Body)`
  color: ${(props) => props.theme.colors.error};
`

const MenuItemSelections = ({
  item,
  groups,
  requiresCustomization,
  setIsCustomize,
}: {
  item: CartItem
  groups: CartItemGroups
  requiresCustomization?: boolean
  setIsCustomize: (isCustomize: boolean) => void
}) => {
  const selectedItem = { ...item, groups: groups }
  const currentOptions = getItemOptions(selectedItem)
  const hasSelections = (currentOptions?.length ?? 0) > 0

  return (
    <MenuItemSelectionsView>
      <MenuItemSelectionsEdit>
        <MenuItemSelectionsTitle>Current Selections: </MenuItemSelectionsTitle>
        <ButtonLink onClick={() => setIsCustomize(true)}>
          {hasSelections ? 'edit selections' : 'customize item'}
        </ButtonLink>
      </MenuItemSelectionsEdit>
      {hasSelections ? (
        <MenuItemSelectionsOptions>
          {currentOptions?.map((option, index) => (
            <MenuItemSelectedOption
              key={`${option.id}-${index}`}
              option={option}
            />
          ))}
        </MenuItemSelectionsOptions>
      ) : (
        <MenuItemSelectionsContainer>
          {requiresCustomization ? (
            <MenuItemSelectionsIncomplete>
              requires customization
            </MenuItemSelectionsIncomplete>
          ) : (
            <Body>nothing selected</Body>
          )}
        </MenuItemSelectionsContainer>
      )}
    </MenuItemSelectionsView>
  )
}

export default MenuItemSelections
